<template>
    <div class="p-fluid bg-white p-3 borda-card-personalizada" style="border-radius: 0.125rem">
        <erros-box :erros="erros"></erros-box>
        <div class="flex flex-row align-items-center justify-content-between">
            <div class="flex flex-row align-items-center justify-content-center">
                <Checkbox
                    class="mr-1"
                    :modelValue="marcado"
                    binary
                    variant="filled"
                    @update:modelValue="atualizarMarcacao($event)"
                    v-if="bordero?.usuarioAtualPodeAprovar && $temAcessoView('BORDEROS-05') && bordero?.status !== 2 && bordero?.status !== 3"
                />
                <Tag class="bg-cinza lato-bolder text-black-alpha-90 mr-1" rounded>nº {{ bordero?.idbordero }}</Tag>

                <Tag rounded class="bg-cinza lato-bolder text-black-alpha-90 mr-1">{{ bordero?.statusDescricao }}</Tag>

                <Tag
                    v-if="bordero?.status === 1 && bordero?.usuarioAtualAprovou"
                    rounded
                    v-tooltip.bottom="
                        `${
                            bordero?.usuarioAtualTipoAprovacao == 1
                                ? 'Você deu sua aprovação de visto neste bordero'
                                : 'Você deu sua aprovação final neste borderô'
                        }`
                    "
                    class="cursor-pointer bg-cinza lato-bolder text-black-alpha-90"
                >
                    <i
                        v-if="bordero?.usuarioAtualTipoAprovacao == 1"
                        class="pi pi-check cursor-pointer"
                        @click="dataFim = null"
                        style="color: #3e6ba8 !important; font-size: 14px"
                    ></i>

                    <font-awesome-icon v-if="bordero?.usuarioAtualTipoAprovacao == 0" icon="check-double" class="text-xs" style="color: #3e6ba8 !important" />
                </Tag>
            </div>

            <div style="background-color: #f3f6fa" class="cursor-pointer border-circle p-2 flex flex-row align-items-center justify-content-center">
                <i
                    v-tooltip.top="'Detalhar Borderô'"
                    class="pi pi-info-circle info-icon cor-icone-detalhar-personalizada font-bold"
                    @click="navegarParaDetalhar"
                    style="font-size: 1.125rem"
                >
                </i>
            </div>
        </div>

        <hr />

        <div>
            <DetalheDado titulo="Descrição">{{ bordero?.descricao }}</DetalheDado>
        </div>

        <hr />

        <div>
            <DetalheDado titulo="Valor do Lote">{{ bordero?.valorFormatado }}</DetalheDado>
        </div>

        <hr />

        <div>
            <DetalheDado titulo="Vencimento">{{ bordero?.validadeFormatada }}</DetalheDado>
        </div>

        <hr />

        <div class="p-fluid flex flex-column">
            <h5 class="align-self-center cor-fonte-personalizada lato-bolder">{{ bordero?.quantidadeAprovacoes }} de 3 aprovações</h5>
            <div
                class="flex flex-row align-items-center justify-content-center"
                v-if="mostrarBotoes && (bordero?.status == 0 || bordero?.status == 1) && bordero?.usuarioAtualPodeAprovar && !bordero?.usuarioAtualAprovou"
            >
                <Button
                    class="lato-bolder bg-btn-reprovar margin-personalizada-btns btn-comum w-full flex flex-row align-items-center justify-content-center"
                    v-if="$temAcessoView('BORDEROS-05')"
                    @click="confirmarAprovarReprovar('reprovar')"
                    style="font-family: 'Lato', Arial, sans-serif; font-weight: 700; font-size: 16px; color: #e0e3e7"
                >
                    Reprovar
                    <i class="pi pi-times mt-1 ml-2"> </i>
                </Button>

                <Button
                    class="lato-bolder bg-btn-aprovar btn-comum w-full flex flex-row align-items-center justify-content-center gap-1"
                    v-if="$temAcessoView('BORDEROS-05')"
                    @click="confirmarAprovarReprovar('aprovar')"
                    style="font-family: 'Lato', Arial, sans-serif; font-weight: 700; font-size: 16px; color: #fff"
                >
                    <span
                        v-if="!$temAcessoView('BORDEROS-06') && !$temAcessoView('BORDEROS-07') && !$temAcessoView('BORDEROS-08')"
                        class="w-full flex flex-row align-items-center justify-content-center gap-1"
                    >
                        Aprovar

                        <i class="pi pi-check mt-1 ml-2"> </i>
                    </span>

                    <span
                        v-if="
                            $temAcessoView('BORDEROS-06') &&
                            $temAcessoView('BORDEROS-07') &&
                            $temAcessoView('BORDEROS-08') &&
                            bordero?.usuarioAtualTipoAprovacao === 0
                        "
                        class="w-full flex flex-row align-items-center justify-content-center gap-1"
                    >
                        Visto

                        <i class="pi pi-check mt-1 ml-2"> </i>
                    </span>
                </Button>
            </div>

            <Button
                class="lato-bolder bg-btn-aprovar btn-comum w-full flex flex-row align-items-center justify-content-center gap-1"
                v-if="
                    $temAcessoView('BORDEROS-06') &&
                    $temAcessoView('BORDEROS-07') &&
                    $temAcessoView('BORDEROS-08') &&
                    bordero?.usuarioAtualTipoAprovacao === 1 &&
                    bordero?.usuarioAtualPodeAprovar
                "
                @click="aprovar()"
                style="font-family: 'Lato', Arial, sans-serif; font-weight: 700; font-size: 16px; color: #fff"
            >
                Transmissão

                <font-awesome-icon icon="check-double" class="text-xs mt-1 ml-2" />
            </Button>
        </div>
    </div>
</template>

<script>
import DetalheDado from './DetalheDado.vue';
import BorderosService from './service';

export default {
    components: {
        DetalheDado,
    },

    props: {
        bordero: {
            type: Object,
        },

        deveMarcar: {
            type: Boolean,
            default: () => false,
        },

        mostrarBotoes: {
            type: Boolean,
            default: () => true,
        },
    },

    emits: ['atualizouMarcacao', 'aprovacaoReprovacao'],

    data() {
        return {
            marcado: false,
            erros: [],
        };
    },

    methods: {
        atualizarMarcacao(novoValor) {
            this.marcado = novoValor;
            this.$emit('atualizouMarcacao', { deveRemover: !novoValor, borderoId: this.bordero?.borderoId });
        },

        navegarParaDetalhar() {
            this.$router.push({ name: 'Detalhar_Bordero', params: { borderoId: this.bordero?.borderoId } });
        },

        confirmarAprovarReprovar(acao = 'aprovar') {
            this.$confirm.require({
                message: `Tem certeza que deseja ${acao.toLowerCase()} o borderô ${this.bordero?.idbordero}?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (acao == 'aprovar') {
                        this.aprovar();
                    } else {
                        this.reprovar();
                    }
                },
            });
        },

        aprovar() {
            this.$store.dispatch('addRequest');
            const aprovarBordero = { borderos: [this.bordero?.borderoId] };
            BorderosService.aprovarBordero(aprovarBordero).then((response) => {
                if (response?.success) {
                    this.$emit('aprovacaoReprovacao');
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: 'Borderô aprovado com sucesso', life: 3000 });
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'Erro ao aprovar borderô', life: 3000 });
                    this.erros = response.errors;
                }
                this.$store.dispatch('removeRequest');
            });
        },

        reprovar() {
            this.$store.dispatch('addRequest');
            const borderoReprovadoDto = { borderos: [this.bordero?.borderoId] };
            BorderosService.reprovarBordero(borderoReprovadoDto).then((response) => {
                if (response?.success) {
                    this.$emit('aprovacaoReprovacao');
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: 'Borderô reprovado com sucesso', life: 3000 });
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'Erro ao reprovar borderô', life: 3000 });
                    this.erros = response.errors;
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },

    watch: {
        deveMarcar(novoValor) {
            this.marcado = novoValor;
        },

        marcado(novoValor) {
            if (this.bordero?.usuarioAtualPodeAprovar) {
                this.$emit('atualizouMarcacao', { deveRemover: !novoValor, borderoId: this.bordero?.borderoId });
            }
        },
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

.lato-bolder {
    font-family: 'Lato', Arial, sans-serif;
    font-weight: 700;
}

.bg-cinza {
    background-color: #ebebeb;
}

.bg-btn-aprovar {
    border-color: #3e6ba8;
    background-color: #3e6ba8;
}

.bg-btn-aprovar:hover {
    border-color: #3e6ba8;
    background-color: #3e6ba8;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.bg-btn-reprovar {
    border-color: #e54d2e;
    background-color: #e54d2e;
}

.bg-btn-reprovar:hover {
    border-color: #e54d2e;
    background-color: #e54d2e;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.btn-comum {
    height: 2.5rem;
}

.margin-personalizada-btns {
    margin-right: 1.125rem;
}

.radius-personalizado {
    width: 5.625rem;
    border-radius: 2.813rem;
}

.borda-card-personalizada {
    border: 1px solid #e0e3e7;
    font-size: 0.875rem;
}

.cor-fonte-personalizada {
    color: #666666;
}

.cor-icone-detalhar-personalizada {
    color: #3d70ff;
}
</style>
